import { gql, useQuery } from '@apollo/client';
import {
  GetGoogleGroupsQuery,
  GetGoogleGroupsQueryVariables,
} from '../../../__generated__/queries-auth';

export const GET_GOOGLE_GROUPS = gql`
  query GetGoogleGroups(
    $first: UnsignedInt!
    $skip: UnsignedInt
    $where: GoogleGroupFilterInput
  ) {
    googleGroups(first: $first, skip: $skip, where: $where) {
      id
      groupTitle
      role {
        id
        slug
      }
    }
  }
`;

export const useGoogleGroups = (
  variables: GetGoogleGroupsQueryVariables,
  skip?: boolean,
) =>
  useQuery<GetGoogleGroupsQuery, GetGoogleGroupsQueryVariables>(
    GET_GOOGLE_GROUPS,
    {
      variables,
      skip,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    },
  );
